import constants from './constants';
import { getPlayerTimeStampFromUnix } from "../api";

export default {
    platformName: () => {
        if(navigator.userAgent.match(/Android/i)) {
            return 'android'
        } else if(navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
            return 'ios'
        }

        return 'any';
    },
    isMobile: () => (window.innerWidth < constants.mobileScreenSize),
    capitalizeFirstLetter: (string) => (string.charAt(0).toUpperCase() + string.slice(1)),
    errorResponseCheck: (response) => {
        if (!response.ok) {
            throw Error(response.status);
        }
        return response;
    },
    errorResponseHandler: function (error) {
        const redirect404 = () => {
                this.props.history.push('/404');
            },
            redirect500 = () => {
                this.props.history.push('/500');
            },
            alertFetchErrorMessage = () => {
                alert('Something went wrong while fetching data');
            };

        /**
         * Redirect to error page in case of 404 response status
         * 400, 419, 500 -> alert message
         * any other error is passed to next error handler
         */
        const handler = {
            '400': alertFetchErrorMessage,
            '404': redirect404,
            '419': alertFetchErrorMessage,
            '500': redirect500
        };

        // If handler can't handle some error, it throws the incomming error to the next catch block
        handler[error.message] ? handler[error.message]() : (() => {
            throw error;
        })();
    },
    getSourceConfigObject: (url) => {
        const videoTypeExtension = url.substr(url.lastIndexOf('.') + 1); // Extracting extension of video, like 'mp4' or 'm3u8'

        return {
            src: url,
            type: constants[videoTypeExtension] || constants[constants.mp4Ext]
        }
    },
    getFileExtension(fileName) {
        return /[.]/.exec(fileName) ? /[^.]+$/.exec(fileName)[0] : undefined;
    },
    /** convert HEX to RGBA and make lighter **/
    getLabelBackgroundColor(hex, alpha = 1, lighterOn = 30) {
        const [r, g, b] = hex.match(/\w\w/g).map(item => {
            return parseInt(item, 16) + lighterOn
        });

        return `rgba(${r},${g},${b}, ${alpha})`;
    },
    getPlayerStartTimeFromTimeStamps(timeStamp, playerTimeStamp, eventId) {
        return new Promise((resolve => {
            if (playerTimeStamp) {
                resolve(Math.floor(playerTimeStamp / 1000));
            } else if (timeStamp) {
                const unixTimeStampInMilliseconds = timeStamp / 1000;

                getPlayerTimeStampFromUnix(eventId, unixTimeStampInMilliseconds)
                    .then(this.errorResponseCheck)
                    .then(response => response.json())
                    .then(response => {
                        resolve(Math.floor(response.pts / 1000))
                    })
                    .catch(() => resolve(0))
            } else {
                resolve(0);
            }
        }));
    },
    formatDate(dateString) {
        const date = typeof dateString === 'string' || typeof dateString === 'number' ? new Date(dateString * 1000) : dateString;

        return `${date.getUTCMonth() + 1}-${date.getUTCDate()}-${date.getUTCFullYear()}`;
    }
};
